import { render, staticRenderFns } from "./ContadorTempoSessao.vue?vue&type=template&id=23e482ca&scoped=true&"
import script from "./ContadorTempoSessao.vue?vue&type=script&lang=js&"
export * from "./ContadorTempoSessao.vue?vue&type=script&lang=js&"
import style0 from "./ContadorTempoSessao.vue?vue&type=style&index=0&id=23e482ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e482ca",
  null
  
)

export default component.exports